import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import req from './utils/request.js';
import utils from './utils/utils.js';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import webChannel from '../public/static/iframe/json/webChannel.json';

// require styles
// import 'swiper/swiper-bundle.css'

Vue.use(VueAwesomeSwiper, /* { default global options } */)

Vue.config.productionTip = false;

Vue.prototype.$req = req;
Vue.prototype.$utils = utils;
Vue.prototype.$bus = new Vue();


router.beforeEach((to,from,next)=>{
	// console.info(to);
	// console.info(from);
	var ismobile = localStorage.getItem('ismobile');
	if(ismobile == null){
	let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
		ismobile = flag ? 1 : 0
	}
	if (to.path) {
		if (window._hmt) {
			window._hmt.push(['_trackPageview','/#' + to.fullPath])
		}
	}

	let channel
	let routerChannel=to.query.channel
	if(routerChannel){
		if(routerChannel==0||routerChannel=="web"){
			channel="web"
		}else if(routerChannel==1||routerChannel=="gamemanager1"){
			channel="gamemanager1"
		}else{
			webChannel.arr.forEach((item) => {
				if(routerChannel==item.channel){
					channel=item.channel
				}
			})
		}

		if(channel){
			sessionStorage.setItem("channel",channel)
		}else{
			sessionStorage.removeItem("channel")
		}
	}


	

	//移动端
	if (ismobile == 1) {
		window._isNoHead = true;
		if(to.path!="/downloadM.html"){
			next({
				path:"/downloadM.html"
			})
		}else{
			next();
		}
	}else{
		// if(to.name == 'gameActive'||to.name == 'downloadM.html'){
		// 	window._isNoHead = true;
		// }else{
		// 	window._isNoHead = false;
		// }
		if(to.path=="/downloadM.html"){
			next({
				path:"/download.html"
			})
		}else{
			next();
		}
		
	}
	
	if(to.name==null){
		next({
			path:"/"
		})
	}
	
});


new Vue({
  router,
	store,
  render: h => h(App)
}).$mount('#app')
